import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Users, MessageCircle, Calendar, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const Docs: React.FC = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Hero */}
      <section className="relative overflow-hidden bg-gradient-to-br from-blue-600 via-teal-500 to-orange-400 text-white pt-32 pb-24">
        <div className="absolute inset-0 bg-dot-white/10" />
        <div className="container mx-auto px-4 relative">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="text-6xl md:text-7xl font-light tracking-tight mb-6 leading-tight">Documentation</h1>
            <p className="text-xl md:text-2xl text-blue-100 leading-relaxed max-w-2xl mx-auto font-light">
              Guides, FAQs, and how-tos for StartupStreak
            </p>
            <div className="flex items-center justify-center gap-4 mt-8">
              <div className="flex items-center gap-2 text-blue-100">
                <BookOpen className="w-5 h-5" />
                <span>Getting Started</span>
              </div>
              <span className="opacity-60">•</span>
              <div className="flex items-center gap-2 text-blue-100">
                <Users className="w-5 h-5" />
                <span>Community Pods</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Community Pods Section */}
      <section id="community-pods" className="py-24 bg-white text-black">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl md:text-6xl font-light mb-6">Community Pods</h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              Community Pods are small groups of entrepreneurs designed for accountability, support, and collective momentum. Get matched based on stage, skills, and goals.
            </p>

            <div className="grid md:grid-cols-3 gap-6 mb-10">
              <div className="p-6 border border-gray-200 rounded-lg">
                <Users className="w-7 h-7 text-blue-600 mb-3" />
                <h3 className="text-lg font-medium text-black mb-2">Small, Focused Groups</h3>
                <p className="text-gray-600 text-sm">Pods of 3-5 founders for deeper accountability</p>
              </div>
              <div className="p-6 border border-gray-200 rounded-lg">
                <MessageCircle className="w-7 h-7 text-blue-600 mb-3" />
                <h3 className="text-lg font-medium text-black mb-2">Async + Live</h3>
                <p className="text-gray-600 text-sm">In-app chat plus optional weekly meetups</p>
              </div>
              <div className="p-6 border border-gray-200 rounded-lg">
                <Calendar className="w-7 h-7 text-blue-600 mb-3" />
                <h3 className="text-lg font-medium text-black mb-2">Weekly Rhythm</h3>
                <p className="text-gray-600 text-sm">Share goals, progress, and blockers</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/signup">
                <Button className="bg-gradient-to-r from-yellow-400 to-orange-500 hover:from-yellow-300 hover:to-orange-400 text-black font-semibold">
                  Get Matched Now
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>
              <Link to="/community">
                <Button variant="outline" className="border-2 text-black">
                  Back to Community
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-24 bg-gradient-to-br from-slate-900 via-blue-900 to-teal-900 text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-dot-white/5" />
        <div className="container mx-auto px-4 relative">
          <div className="text-center max-w-3xl mx-auto">
            <h3 className="text-4xl md:text-5xl font-light mb-6">Need more help?</h3>
            <p className="text-blue-200 mb-8">Email us and we’ll get back within a few hours.</p>
            <a href="mailto:hello@startupstreak.com">
              <Button size="lg" className="bg-gradient-to-r from-yellow-400 to-orange-500 text-black font-semibold">
                Email Support
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Docs;
